import firebase from 'firebase/app';
import 'firebase/auth';
import 'firebase/database';

export {firebase};

firebase.initializeApp({
    apiKey: 'AIzaSyBrP74MaEj8iQ9nnWa_Rc_7xpsEUYOxUMA',
    authDomain: 'saga-310bf.firebaseapp.com',
    databaseURL: 'https://saga-310bf.firebaseio.com/'
});

export const auth = firebase.auth();
export const db = firebase.database();

export function signIn() {
    let provider = new firebase.auth.GoogleAuthProvider();
    return auth.signInWithPopup(provider);
}

export function signOut() {
    return auth.signOut();
}



// WEBPACK FOOTER //
// ./src/lib/firebase.js